import React, { useState } from 'react';
import './Login.css';
import { useDispatch } from 'react-redux';
import { setTokens } from '../../store/tokensSlice'; // Import akcji Redux
import { ReactComponent as TeamMeLogo2 } from '../icons/logo2.svg';
import ApiService from '../api_services/apiService.jsx'; // Import ApiService

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault(); // Zapobiega przeładowaniu strony

    try {
      // Wysłanie żądania POST do API
      const response = await ApiService.post('/api/auth/login', {
        login: username,
        pass: password,
      });

      console.log('Odpowiedź z API:', response); // Wyświetlenie całego obiektu odpowiedzi w konsoli

      // Przykład: ustawienie tokenu w Redux
      if (response.data && response.data.userRole === '[ADMIN]') {
        dispatch(setTokens({
          accessToken: response.data.accessToken,
          refreshToken: response.data.refreshToken,
          userEmail: response.data.userEmail,
          userPhoneNumber: response.data.phoneNumber,
          accessTokenExpiration: response.data.accessTokenExpiresAt,
          refreshTokenExpiration: response.data.refreshTokenExpiresAt,
          userRole: response.data.userRole,
        })); // Ustawienie tokenów w Redux        
      } else if (response.data && response.data.userRole !== '[ADMIN]')  {
        alert('Nie jesteś administratorem! Nie masz dostepu do tego systemu!');
      } else {
        alert('Nieprawidłowa odpowiedź z serwera.');
      }
    } catch (error) {
      console.error('Błąd podczas logowania:', error);
      alert('Nie udało się zalogować. Sprawdź swoje dane logowania.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h1 className="login-title">
          <TeamMeLogo2 />
          TeamMe
        </h1>
        <p className="login-subtitle">Logowanie do panelu administracyjnego</p>
        <p className="login-instruction">Uzupełnij dane, aby się zalogować</p>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Login</label>
            <input
              type="text"
              id="username"
              placeholder="Wpisz login"
              value={username}
              onChange={(e) => setUsername(e.target.value)} // Aktualizacja stanu loginu
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Hasło</label>
            <input
              type="password"
              id="password"
              placeholder="Wpisz hasło"
              value={password}
              onChange={(e) => setPassword(e.target.value)} // Aktualizacja stanu hasła
            />
          </div>
          <button type="submit" className="login-button">
            Zaloguj się
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;